<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>
<style lang="scss">
  @import "./styles/common.scss";
</style>
<style>
  @font-face {
    font-family: nike1;
    src: url('../static/fonts/TradeGothicforNike365-BdCn.ttf') format('truetype')
  }
  @font-face {
    font-family: nike2;
    src: url('../static/fonts/PingFangRegular.ttf') format('truetype')
  }
  #app {
    font-family: nike2, nike1, 'Avenir', Helvetica, Arial, sans-serif;
  }
  /* 这里有个很大的坑,用了VueGallery以后body的overflow会变成hidden */
  body {
    margin: 0;
    background: #e6e9f2;
    overflow: auto!important;
  }
  a {
    margin-left: 10px
  }
  a+.el-button {
    margin-left: 10px
  }
  /* VueGallery额外样式 */
  a.close {
    display: none!important;
  }
  a.next {
    color: transparent!important;
  }
  a.prev {
    color: transparent!important;
  }
  .blueimp-gallery {
    position: fixed!important;
    width: 297px!important;
    height: 640px!important;
    top: 50%!important;
    margin-top: -264px!important;
    left: 300px!important;
    border-radius: 28px!important;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue